export default __webpack_public_path__ + "static/media/charity_New.c915e620.gif";